import Swiper from 'swiper';
import forms from '../modules/Forms/forms';
import simulationOneForm from '../modules/Utils/simulation_one_form';

forms();
simulationOneForm();

// Toggle details section and icon
window.addEventListener('DOMContentLoaded', function () {
    const simulationResults = document.querySelectorAll('.simulation-result');

    simulationResults.forEach(simulation => {
        const toggleBtn = simulation.querySelector('#toggle-details');
        const detailsSection = simulation.querySelector('#details-section');
        const plusIcon = simulation.querySelector('#plus-icon');
        const minusIcon = simulation.querySelector('#minus-icon');

        if (toggleBtn && detailsSection && plusIcon && minusIcon) {
            toggleBtn.addEventListener('click', function () {
                const isOpen = !detailsSection.classList.contains('hidden');
                if (isOpen) {
                    detailsSection.classList.add('hidden');
                    plusIcon.classList.remove('hidden');
                    minusIcon.classList.add('hidden');
                    simulation.classList.remove('details-open');
                } else {
                    detailsSection.classList.remove('hidden');
                    plusIcon.classList.add('hidden');
                    minusIcon.classList.remove('hidden');
                    simulation.classList.add('details-open');
                }
            });
        }
    });

    // swiper
    const customSlider = new Swiper('.custom-slider', {
        slidesPerView: 3.2,
        spaceBetween: 24,
        loop: true,
        speed: 800,
        freeMode: true,
        centeredSlides: true,
        centeredSlidesBounds: true,

        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.15,
                spaceBetween: 16,
                centeredSlides: false,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3.2,
                spaceBetween: 24,
            },
        },
    });
});
